module.exports = __webpack_public_path__ + "img/7.ad5c97fc.png";